<div
  class="max-w-md mx-auto bg-white rounded-2xl shadow-xl border border-gray-100 p-6 sm:p-8"
>
  <!-- Header with Refresh/Clear Icon in Top Right -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h3 class="text-xl font-bold text-gray-800">Draw Your Signature</h3>
      <p class="text-sm text-gray-500 mt-0.5">
        Please sign clearly inside the box below
      </p>
    </div>

    <!-- Clear / Refresh Button -->
    <button
      type="button"
      (click)="clearPad()"
      title="Clear signature"
      class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </button>
  </div>

  <!-- Canvas Container -->
  <div
    class="relative w-full h-48 bg-[#4f5aed14] rounded-xl border-2 border-dashed border-[#4f5aed] hover:border-indigo-400 transition-colors overflow-hidden mb-4"
  >
    <canvas
      #canvas
      class="w-full h-full cursor-crosshair touch-none"
      (mousedown)="startDrawing($event)"
      (mousemove)="draw($event)"
      (mouseup)="stopDrawing()"
      (mouseleave)="stopDrawing()"
      (touchstart)="startDrawing($event)"
      (touchmove)="draw($event)"
      (touchend)="stopDrawing()"
    ></canvas>

    <!-- Watermark Hint -->
    <span
      class="absolute bottom-3 right-3 text-xs text-gray-300 select-none pointer-events-none font-medium"
    >
      Sign here
    </span>
  </div>

  <!-- Error Message -->
  @if(isError){
  <div
    class="mb-4 p-3 bg-red-50 border-l-4 border-red-500 text-red-700 text-sm rounded-r-lg flex items-center space-x-2"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5 text-red-500 shrink-0"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clip-rule="evenodd"
      />
    </svg>
    <span>Please provide a signature first.</span>
  </div>
  }

  <!-- Button Group (Cancel & Save) -->
  <div class="flex items-center gap-3">
    <button
      type="button"
      (click)="cancel()"
      class="flex-1 px-4 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 active:bg-gray-100 rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
    >
      Cancel
    </button>

    <button
      type="button"
      (click)="savePad()"
      class="flex-1 px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 rounded-xl shadow-md shadow-indigo-200 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      Save Signature
    </button>
  </div>
</div>
